import { Guid } from '@web/utils';
import { PaymentMethodCode } from '@web/shared/module/shop';
import { jsonMember } from 'typedjson';

export class AdminPaymentMethodResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: PaymentMethodCode;

  @jsonMember(String)
  public readonly name!: string;
}
